<template>
  <div class="top-summary">
    <div
      v-for="(block, index) in summaryBlocks"
      :key="index"
      class="summary-block"
      :class="block.class"
    >
      <div class="label">
        {{ block.label }}
      </div>
      <div class="value">
        {{ block.value }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useOfferSheetStore } from '@/stores/offer-sheet';
import { formatCurrency } from '@/helpers/currency';
import { inflect } from '@/helpers/inflection';

const offerSheetStore = useOfferSheetStore();
const summary = computed(() => offerSheetStore.offerSheet?.summary);

const summaryBlocks = computed(() => {
  return [
    {
      label: 'Artist Potential',
      value: formatCurrency(summary?.value?.artistPotential),
      class: 'bg-vp-yellow-light',
    },
    {
      label: 'Promoter Potential',
      value: formatCurrency(summary?.value?.promoterPotential),
      class: 'bg-vp-orange-light',
    },
    {
      label: 'Net Potential',
      value: formatCurrency(summary?.value?.netPotential),
      class: 'bg-vp-blue-lighter',
    },
    {
      label: 'Split Point',
      value: formatCurrency(summary?.value?.splitPoint),
      class: 'bg-vp-blue-light2',
    },
    {
      label: 'Breakeven',
      value: `${summary?.value?.breakeven ?? 0} ${inflect(summary?.value?.breakeven ?? 0, 'ticket')}`,
      class: 'bg-vp-pink-lighter',
    },
    {
      label: 'Overage',
      value: formatCurrency(summary?.value?.overage),
      class: 'bg-vp-gray-light-2',
    },
  ];
});
</script>
